module.exports = __webpack_public_path__ + "static/media/look.9768ecd1.png";